const _ = require('underscore');
const Backbone = require('backbone');

module.exports = Backbone.Collection.extend({
  initialize() {
    if (!this.collection) {
      this.collection = this.constructor;
    }
  },
  fetchUrl() {
    return this.url();
  },
  fetch(options) {
    const extendedOptions = _.extend({ url: this.fetchUrl() }, options);
    return Backbone.Collection.prototype.fetch.call(this, extendedOptions);
  },
  extend(models, properties) {
    const self = this;
    const ExtendedCollection = this.constructor.extend(properties);
    const collection = new ExtendedCollection(models);

    collection.on('update', (collection, options) => {
      self.merge(collection.models, options);
    });

    return collection;
  },
  merge(models, options) {
    return this.add(models, _.extend({ merge: true }, options));
  },
  findWhere(attributes, createNew) {
    let model = Backbone.Collection.prototype.findWhere.call(this, attributes);

    if (!model && createNew) {
      model = new this.model(attributes);
      model.collection = this;
      model.once('request', () => {
        model.collection.add(model);
      });
    }

    return model;
  },
  removeAll(options) {
    const models = [];
    this.set(models);

    Backbone.sync(
      'delete',
      this,
      _.extend(
        {
          url: this.fetchUrl()
        },
        options
      )
    );
  }
});



// WEBPACK FOOTER //
// ./src/extensions/relational-collection.js